import { TabNames } from '@/pages-v2/home/storeList/component/StoreTabs/constants'
import VueI18n from '@/i18n/locale'

// 静态枚举
import { SHOP_FILTER_OPTIONS, BIZ_STATUS_OPTIONS } from '@/consts'
import { SIGN_PARTY_TYPE_LIST } from '@/config/sign/enums'
import { sortTypeEnum } from './utils'

// 默认的显示有交互的筛选项值
export const defaultInteractionFilterValues = {
  globalLoading: false,
  // phoneInfo
  phoneInfo: {},
  // --- 商户信息相关
  notMyStore: false, // 标记-非我负责的门店（false-未选中该标记，true-选中该标记） 【只传商圈】
  status: [], // 商机状态
  potential: [], // 商机等级
  rPerformance: [], // 商户等级
  type: [], // 门店类型 【商圈不传】
  bizStatus: [], // 经营状态
  storeFrontStatus: [], // sotreFront适配
  priority: [], // 标签
  // --- 诊断分数
  diagnosisScoreStart: 0,
  diagnosisScoreEnd: 100,

  // ----排序信息
  sortType: 0, // 排序类型：0-默认  1-诊断分数从低到高  2-诊断分数从高到低  3-本月完单量从低到高  4-本月完单量从高到低  5-完单变化量从低到高  6-完单变化量从高到低 7-本月R burn/GMV从低到高 8-本月R burn/GMV从高到低 9-R burn/GMV变化量从低到高  10-R burn/GMV变化量从高到低
  // --- 业务策略 & 标签
  arrTag: [], // 标签
  // --- 销售信息
  bdUserName: [],
}

// 重构的state
export default {
  surveySchema: {}, // 问卷schema
  surveyData: {}, // 问卷答案
  surveyMsgTitle: {}, // 问卷标题
  firstGetMsgTime: '', // 首次获取问卷的时间
  timestamp: 0,
  geoErr: false, // 获取不到经纬度信息和定位城市
  filterSelectNum: 0, // 筛选项选择了多少条，为了无数据时展示清空筛选项按钮
  otherPageArrStrategyTagId: [], // 其他页面跳转过来的地方设置【业务策略标签】名称
  workbenchTagIdsAndCity: {
    city: [],
    tagIds: [],
  }, // 存储首页点击的数据
  unCompleteShopIds: [], // 点击营销活动要把店铺带入门店页
  expireShopIds: [],
  newRsListShopIds: [], // 点击消息列表 查看活动
  myStoreTabFromNewStore: false,
  isFromNewRsFlag: false, // 点击消息列表 查看活动
  showAllDataPop: false, // 是否展示所有营销活动的弹窗
  myStoreTab: false,
  strategyId: 0, // 记录当前点击的活动类型 1. 营销 2. SME/CKA 3. 优选好店
  promoItem: {},
  loading: true,
  searchNot: false,
  currentTab: 'priorityStore',
  filterValue: {
    requestType: 0, // 请求类型，1-公海，2-私海，3-高优门店, 4-My Area
    // --- 定位关系
    lat: 0,
    lng: 0,

    // --- 城市相关【普通】
    cityId: '', // 城市ID
    bdAreaIds: [], // 商圈集合
    // --- 城市相关【商圈】
    AreaCityId: '', // 城市ID
    AreaAreaIds: [], // 商圈集合
    ...defaultInteractionFilterValues,
  },
  filterOptions: {
    // --- 内部多个筛选 ---
    notMyStore: [
      {
        label: VueI18n.t('FoodB_030_SQUQ_YDRS' /** 非我的门店 */),
        value: true,
      },
    ], // 标记-非我负责的门店（false-未选中该标记，true-选中该标记） 【只传商圈】
    status: SHOP_FILTER_OPTIONS.filter(item => item.value !== 'status:-1'), // 商机状态
    countByStatus: '',
    potential: [], // 商机等级
    rPerformance: [], // 商户等级
    type: SIGN_PARTY_TYPE_LIST, // 门店类型 【商圈不传】
    bizStatus: BIZ_STATUS_OPTIONS, // 经营状态
    storeFrontStatus: [],
    priority: [],
    // --- 外层筛选 ---
    cityIds: [], // 城市ID(普通)
    areaCityIds: [], // 城市ID(商圈)
    sortType: sortTypeEnum,
    arrTag: [], // 标签
    bdUserName: [],
  },
  strategyTagData: [],
  lists: {
    [TabNames.priority.key]: {
      // --- 分页信息
      pageNo: 1,
      // pageSize: 20,
      total: 0,
      data: [],
    },
    [TabNames.area.key]: {
      // --- 分页信息
      pageNo: 1,
      // pageSize: 20,
      total: 0,
      data: [],
    },
    [TabNames.my.key]: {
      // --- 分页信息
      pageNo: 1,
      // pageSize: 20,
      total: 0,
      data: [],
    },
    [TabNames.all.key]: {
      // --- 分页信息
      pageNo: 1,
      // pageSize: 20,
      total: 0,
      data: [],
    },
  },
}
